<app-top-bar></app-top-bar>


<div id="hero-container">
    <img id="hero" src="img/landing-page/hero.webp" alt="André Groß">


    <div id="title-section">
        <p id="city"> {{ contentService.content().general.address.city }}</p>
        <h1>André Groß</h1>
        <p id="subtitle">Frontend Developer</p>
    </div>
</div>